import { useAuth } from '../../context/AuthContext';
import CoreModules from '../../component/executive/coreModules/CoreModules';

const CORE_MODULE_IDS = [
  'livestock-population',
  'markets-trade',
  'infrastructure',
  'workforce-institutional',
  'planning-reporting',
  'conflicts-dispute',
];

const FieldDashboard = () => {
  const { user } = useAuth();

  const currentYear    = new Date().getFullYear();
  const currentQuarter = `Q${Math.ceil((new Date().getMonth() + 1) / 3)}`;
  const userName  = user?.name || user?.username || 'Field Officer';
  const userLGA   = user?.lga || user?.lgaName || 'LGA';
  const userState = user?.state || user?.stateName || 'State';

  return (
    <div className="p-6 bg-white rounded-md shadow-md min-h-screen">
      {/* Role banner */}
      <div className="rounded-2xl bg-gradient-to-r from-[#0f5c18] via-[#197d1f] to-[#2d9724] px-6 py-5 text-white mb-2">
        <div className="flex flex-wrap items-start justify-between gap-4">
          <div>
            <p className="text-[10px] font-bold uppercase tracking-widest text-green-200 mb-1">
              Field Capture Dashboard
            </p>
            <h1 className="text-xl font-black leading-tight">Welcome, {userName}</h1>
            <div className="mt-2 flex flex-wrap items-center gap-2">
              <span className="inline-flex items-center rounded-full bg-white/15 border border-white/20 px-2.5 py-0.5 text-xs font-semibold">
                {userLGA}
              </span>
              <span className="inline-flex items-center rounded-full bg-white/15 border border-white/20 px-2.5 py-0.5 text-xs font-semibold">
                {userState}
              </span>
          
            </div>
          </div>
          <div className="text-right text-xs text-green-200 shrink-0">
            <p className="font-semibold">LGA Field Officer · R05</p>
            <p className="mt-0.5 opacity-75">Scope locked to own LGA</p>
            <p className="mt-0.5 opacity-75">Click any module to open its records</p>
          </div>
        </div>
      </div>

      {/* Core module cards — 6 field modules only */}
      <CoreModules filter={CORE_MODULE_IDS} title="My Modules" />
    </div>
  );
};

export default FieldDashboard;
